<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>JWNET未加入業者詳細</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              事業者コード
            </div>
            <h4>{{ trader.code }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              事業者名
            </div>
            <h4>{{ trader.name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              業者区分
            </div>
            <h4>{{ trader.subscriber_type | subscriber_type_to_label }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              許可番号（下6桁）
            </div>
            <h4>{{ trader.permit_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              所在地
            </div>
            <h4>〒{{ trader.zip_code }}&emsp;{{ trader.address }}&nbsp;</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              電話番号
            </div>
            <h4>{{ trader.phone_number }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <!-- /JWNET未加入業者 -->
      <v-tabs
        v-model="traderForm"
        background-color="blue lighten-4"
        centered
        icons-and-text
        fixed-tabs
      >
        <v-tabs-slider />

        <v-tab href="#tab-locations">
          事業場
          <v-icon>mdi-factory</v-icon>
        </v-tab>

      </v-tabs>
      <v-tabs-items v-model="traderForm">
        <!-- 事業場 -->
        <v-tab-item value="tab-locations">
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-card outlined>
                    <v-data-table
                      :headers="locationTableHeaders"
                      :items="traderLocations"
                      :items-per-page="-1"
                      dense
                      disable-sort
                      hide-default-footer
                    >
                      <template v-slot:[`item.name`]="{ item }">
                        <span :title="item.name">{{ item.name | truncate(20) }}</span>
                      </template>
                      <template v-slot:[`item.address`]="{ item }">
                        <div>〒{{ item.zip_code }}</div>
                        <span>{{ item.address | truncate(25) }}</span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-row dense>
            <v-col>
              <v-pagination
                v-model="locationPage"
                :length="locationPagination.total_pages"
                :total-visible="locationTotalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="changePage"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <!-- /事業場 -->
      </v-tabs-items>
      <v-card-actions>
        <v-btn
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          @click="editButtonClickEvent"
        >
          編集
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '../../../../components/Confirm'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'DriverMasterNonSubscribeTraderShow',
  components: {
    Confirm
  },
  mixins: [
  ],
  data () {
    return {
      traderForm: 'basicTab',
      breadcrumbs: [
        { text: 'JWNET未加入業者一覧', disabled: false, to: '/driver/masters/non_subscribe_traders', exact: true },
        { text: 'JWNET未加入業者詳細', disabled: true, to: '' },
      ],
      /* 事業者 **/
      trader: [],

      /* 事業場 **/
      traderLocations: [],
      locationTableHeaders: [
        { value: 'code', text: '事業場コード' },
        { value: 'name', text: '事業場名' },
        { value: 'location_type_name', text: '事業場区分' },
        { value: 'address', text: '住所' },
        { value: 'phone_number', text: '電話番号' },
      ],
      locationPage: 1,
      locationTotalVisible: 7,
      locationPagination: {
        total_pages: 0,
        total_count: 0
      },

    }
  },
  computed: {
    ...mapGetters('DriverAuthentication', [
      'isDemoEnv',
    ]),
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
      isJwMode: 'use_jw_mode',
    }),
  },
  created() {
    this.fetchTrader({ id: this.$route.params.id }).then((content) => {
      this.trader = content
    })
    this.searchTraderLocations()
  },
  methods: {
    ...mapActions('DriverMasterNonSubscribeTrader', {
      fetchTrader: 'show',
      deleteTrader: 'destroy',
    }),
    ...mapActions('DriverMasterNonSubscribeTraderLocation', {
      fetchTraderLocations: 'index',
    }),

    cancelButtonClickEvent () {
      this.$router.push({name: 'DriverMasterNonSubscribeTraders'})
    },
    editButtonClickEvent () {
      this.$router.push({name: 'DriverMasterNonSubscribeTraderEdit', params: { id: String(this.trader.id) }})
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteTrader({id: this.trader.id }).then(() =>{
            this.$router.push({name: 'DriverMasterNonSubscribeTraders'})
          })
        }
      })
    },
    changePage () {
      this.searchTraderLocations()
    },
    /**
     * JWNET未加入事業場検索
     */
    searchTraderLocations () {
      this.fetchTraderLocations({ trader_id: this.$route.params.id , page: this.locationPage}).then((content) => {
        this.traderLocations = content.trader_locations
        this.locationPagination = content.pagination
      })
    },
  }
}
</script>

<style lang="scss">

</style>
